module.exports = __webpack_public_path__ + "static/img/v41Bg-p.d2c1282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v41Bg-p.png
// module id = UpED
// module chunks = 1